import { Item } from "@react-stately/collections";
import { Menu } from "./LegacyMenu";
import {
  MenuDropdown,
  MenuDropdownProps,
  MenuDropdownTriggerProps,
  MenuDropdownTriggerRenderProp,
} from "./MenuDropdown";
import { MenuItemProps } from "./MenuItem";
import { MenuRoot, MenuRootProps } from "./MenuRoot";

export declare namespace Menu {
  export type DropdownProps<T extends object> = MenuDropdownProps<T>;
  export type DropdownTriggerProps = MenuDropdownTriggerProps;
  export type DropdownTriggerRenderProp = MenuDropdownTriggerRenderProp;
  export type ItemProps = MenuItemProps;
  export type RootProps<T extends object> = MenuRootProps<T>;
}

type ExtendedMenu = typeof Menu & {
  Dropdown: typeof MenuDropdown;
  Item: (props: MenuItemProps) => JSX.Element;
  Root: typeof MenuRoot;
};

const ExtendedMenu = Menu as ExtendedMenu;

ExtendedMenu.Dropdown = MenuDropdown;
ExtendedMenu.Item = Item as ExtendedMenu["Item"];
ExtendedMenu.Root = MenuRoot;

export { MenuAction, MenuItem } from "./LegacyMenu";
export type { MenuActionProps } from "./LegacyMenu";
export { ExtendedMenu as Menu };
